var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 0.0339966H7C5.34315 0.0339966 4 1.37714 4 3.034V20.966C4 22.6229 5.34315 23.966 7 23.966H17C18.6569 23.966 20 22.6229 20 20.966V3.034C20 1.37714 18.6569 0.0339966 17 0.0339966ZM12 22.466C11.4477 22.466 11 22.0183 11 21.466C11 20.9137 11.4477 20.466 12 20.466C12.5523 20.466 13 20.9137 13 21.466C13 22.0183 12.5523 22.466 12 22.466ZM17 18.966C17.5523 18.966 18 18.5183 18 17.966V3.534C18 2.98169 17.5523 2.534 17 2.534H7C6.44772 2.534 6 2.98169 6 3.534V17.966C6 18.5183 6.44772 18.966 7 18.966H17Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneMobile);
export default __webpack_public_path__ + "static/media/phoneMobile.4fbfa9b7.svg";
export { ForwardRef as ReactComponent };